import { ReportService } from 'data/services';
import { ReportServiceInterface } from 'domain/services';
import { makeGetAllCoursesUser } from 'main/factories/usecases/courses/remote-get-all-courses-user-factory';
import { makeRemoteReportRadino } from 'main/factories/usecases/report/report-radino-factory';
import { makeGetAllSemestersUser } from 'main/factories/usecases/semesters/remote-get-all-semesters-user-factory';

export const makeReportService = (): ReportServiceInterface => {
  return new ReportService({
    reportRadino: makeRemoteReportRadino(),
    getAllCoursesUser: makeGetAllCoursesUser(),
    getAllSemestersUser: makeGetAllSemestersUser(),
  });
};
